// extracted by mini-css-extract-plugin
export default {"container":"PaginationItem_container__FG1Sg","default":"PaginationItem_default__HJjer","red":"PaginationItem_red__HCx50"};